import styled from 'styled-components';

const BULLET_SIZE = 40;
const LI_PADDING = BULLET_SIZE + 16;
const LINE_SIZE = 2;
const LINE_POS = (BULLET_SIZE - LINE_SIZE) / 2;

export const StepBoxSC = styled.ol<{ showLine?: boolean }>`
  list-style: none;
  padding: 0;
  margin-bottom: 16px;

  li {
    counter-increment: ordered-list-counter;
    position: relative;
    padding-left: ${LI_PADDING}px;
    padding-bottom: 32px;
    padding-top: 8px;

    ${({ theme }) => theme.mappedTypography.h6.default};

    .step-box-description {
      color: ${({ theme }) => theme.color.tint.secondary};
      margin-top: 8px;
    }
  }

  li:last-child {
    padding-bottom: 0px;
  }

  li::before {
    content: ${({ showLine }) => (showLine ? "''" : 'none')};
    position: absolute;
    top: ${LINE_POS}px;
    left: ${LINE_POS}px;
    width: ${LINE_SIZE}px;
    height: 100%;
    z-index: 1;
    background-color: ${({ theme }) => theme.color.surface.info};
  }

  li:last-child:before {
    content: none;
  }

  li::after {
    content: counter(ordered-list-counter) '.';

    position: absolute;

    top: 0;
    left: 0;
    width: ${BULLET_SIZE}px;
    height: ${BULLET_SIZE}px;
    z-index: 1;

    display: flex;
    align-items: center;
    justify-content: center;

    ${({ theme }) => theme.mappedTypography.h5.strong};

    color: ${({ theme }) => theme.color.tint.onPrimary};
    background-color: ${({ theme }) => theme.color.surface.info};
    border-radius: 100%;
  }
`;
